<template>
<div class="tenantMain tenantInfo position-relative" v-bind:class="{'run-loading':(loadings.login || loadings.property || loadings.site || loadings.raiseCase)}">
    <div class="tenantCard tenantTimeLine">
        <div class="logo text-center">
            <img src="/img/tenants-logo-small.png" alt="">
        </div>
        <div class="timeline" :class="`step-${step}`">
            <div class="node node-1" v-bind:class="{active : step >=1 }"><span class="node-label">Tenants Infomation</span></div>
            <div class="node node-2" v-bind:class="{active : step >=2 }"><span class="node-label">Feedback</span></div>
            <div class="node node-3" v-bind:class="{active : step >=3 }"><span class="node-label">Review & Submit</span></div>
        </div>
    </div>
    <transition name="fade" mode="out-in" v-if="step === 1">
        <div class="tenantCard tenantForm tenantLogin">
            <div class="header text-center">
                <h3>Login</h3>
                <div class="control">
                    <gofix-button :disabled="true" class="mr-3" label="I'm a tenant" @click="tenantForm = 'user'" :outline="tenantForm === 'guest'"></gofix-button>
                    <gofix-button label="I'm a guest" @click="showGuest" :outline="tenantForm === 'user'"></gofix-button>
                </div>
            </div>
            <div class="main tenantUser" v-if="tenantForm === 'user'">
                <gofix-form-input label="Email" autocomplete="email" v-model="user.email"></gofix-form-input>
                <gofix-form-input label="Password" :type="passwordType" autocomplete="new-password" v-model="user.password">
                    <template v-if="is_show_icon_pwd" slot="gofixInput:text:after-input">
                        <span class="eye_icon" v-bind:class="{eyeOff : passwordType === 'password'}" @click="changePasswordType"><img src="img/eye_icon.png" alt=""></span>
                    </template>
                </gofix-form-input>
                <gofix-button class="mr-3" label="Next" :disabled="!user.email || !user.password" large @click="checkUser"></gofix-button>
            </div>
            <div class="main tenantGuest" v-if="tenantForm === 'guest'">
                <div class="fields">
                    <div class="field span-12">
                        <gofix-form-dropdown v-if="!propertyId" label="Site to report" vLabel="site_name" v-model="site_model" :options="sites" required showIconRequired>
                        </gofix-form-dropdown>
                    </div>
                    <div class="field span-6">
                        <div class="fields">
                            <div class="field span-4">
                                <gofix-form-dropdown
                                        label="Salutation"
                                        vLabel="reference_value_text"
                                        :reduce="option => option.reference_value_text"
                                        v-model="requestor.salutation"
                                        :options="salutationOptions">
                                </gofix-form-dropdown>
                            </div>
                            <div class="field span-8">
                                <gofix-form-input label="First Name" v-model="requestor.first_name" required showIconRequired></gofix-form-input>
                            </div>
                        </div>
                    </div>
                    <div class="field span-6">
                        <gofix-form-input label="Last Name" v-model="requestor.last_name" required showIconRequired></gofix-form-input>
                    </div>
                    <div class="field span-6">
                        <gofix-form-input label="Company" v-model="requestor.company"></gofix-form-input>
                    </div>
                    <div class="field span-6">
                        <gofix-form-input label="Email" v-model="requestor.email" required showIconRequired></gofix-form-input>
                    </div>
                    <div class="field span-6">
                        <gofix-form-input-number label="Office Phone Number" v-model="requestor.primary_phone" :integer-limit="15" :include-thousands-separator="false" :allowDecimal="false">
                        </gofix-form-input-number>
                    </div>
                    <!-- <div class="field span-6">
                        <gofix-form-input-number label="Mobile Number" v-model="requestor.secondary_phone" :integer-limit="15" :include-thousands-separator="false" :allowDecimal="false" required showIconRequired>
                        </gofix-form-input-number>
                    </div> -->
                    <div class="field span-6">
                        <gofix-form-dropdown
                                label="Preferred Mode Of Contract"
                                vLabel="reference_value_text"
                                :reduce="option => option.reference_value_text"
                                v-model="requestor.preferred_contact_mode"
                                :options="preferred_mode">
                        </gofix-form-dropdown>
                    </div>
                    <div class="field span-12 mb-4  text-center">
                        <b-form-checkbox v-model="isSign">
                            <span class="ml-2">By signing in, you agree to our 
                                <a href="/privacy-policy.html" target="blank">Terms of use and Privacy Policy</a>
                            </span>
                        </b-form-checkbox>
                    </div>
                    <div class="field span-12 text-center">
                        <gofix-button label="Next" :disabled="!requestor.first_name || !requestor.last_name || !requestor.email || !isSign" large @click="step = 2"></gofix-button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
    <transition name="fade" mode="out-in" v-if="step === 2">
        <div class="tenantCard tenantForm tenantFeedback">
            <div class="header text-center">
                <h3>Feedback / Message </h3>
            </div>
            <div class="main">
                <div class="fields">
                    <div class="field span-12">
                        <p class="mb-2 fz-12">** For quicker response, please assist to select <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 292.362 292.362" class="vue-treeselect__control-arrow"><path d="M286.935 69.377c-3.614-3.617-7.898-5.424-12.848-5.424H18.274c-4.952 0-9.233 1.807-12.85 5.424C1.807 72.998 0 77.279 0 82.228c0 4.948 1.807 9.229 5.424 12.847l127.907 127.907c3.621 3.617 7.902 5.428 12.85 5.428s9.233-1.811 12.847-5.428L286.935 95.074c3.613-3.617 5.427-7.898 5.427-12.847 0-4.948-1.814-9.229-5.427-12.85z"></path></svg> Location, <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 292.362 292.362" class="vue-treeselect__control-arrow"><path d="M286.935 69.377c-3.614-3.617-7.898-5.424-12.848-5.424H18.274c-4.952 0-9.233 1.807-12.85 5.424C1.807 72.998 0 77.279 0 82.228c0 4.948 1.807 9.229 5.424 12.847l127.907 127.907c3.621 3.617 7.902 5.428 12.85 5.428s9.233-1.811 12.847-5.428L286.935 95.074c3.613-3.617 5.427-7.898 5.427-12.847 0-4.948-1.814-9.229-5.427-12.85z"></path></svg> levels and rooms</p>
                        <gofix-form-tree label="Location" :options="properties.tree" placeholder="" v-model="feedback.location" :normalizer="normalizerProperties" search-nested required showIconRequired valueFormat="object" :desc="feedback.location ? feedback.location.root_path : ''">
                        </gofix-form-tree>
                    </div>
                    <div class="field span-12">
                        <!--<gofix-form-dropdown
                                label="Nature of Feedback"
                                v-model="feedback.nature_of_feedback"
                                :reduce="option => option.reference_value_text"
                                vLabel="reference_value_text"
                                :options="natureOfFeedbackOptions"
                                required showIconRequired>
                        </gofix-form-dropdown>-->
                        <gofix-form-tree
                            label="Nature of Feedback" 
                            :options="treeNatureFeedBack" 
                            :normalizer="normalizerNatureFeedBack" 
                            :load-options="loadOptionNatureFeedBack" 
                            valueFormat="object"
                            v-model="nature_feedback_model" 
                            :required="true" :show-icon-required="true" 
                            class="gofixInputNoMinWidth">
                        </gofix-form-tree>
                    </div>
                    <div class="field span-12">
                        <gofix-form-tree :user-value-label-slot="true"
                            label="Type of Service"
                            :options="treeServiceCategory"
                            :normalizer="normalizerServiceCategory"
                            :load-options="loadOptionServiceCategory"
                            valueFormat="object"
                            v-model="feedback.service_category"
                            class="gofixInputNoMinWidth">
                            <template slot="gofixTreeSelect:value-label" slot-scope="{ node }">{{ node.raw.name }}</template>
                        </gofix-form-tree>
                    </div>
                    <div class="field span-12">
                        <gofix-form-input-textarea label="Feedback Details" :rows="5" required showIconRequired v-model="feedback.feedback_detail"></gofix-form-input-textarea>
                    </div>
                    <div class="field span-12 mb-4">
                        <div class="d-flex flex-wrap">
                            <gofix-button class="icon-svg icon-svg-right mr-2 mb-2" v-for="(attachment,index) in feedback.attachments" :label="attachment.name" outline dark :key="index">
                                <template slot="gofix:button:afterLabel">
                                    <span class="icon" @click="removeImage(index)">
                                        <svg width="12" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M13.3 0.99404C13.1131 0.797476 12.8595 0.687011 12.595 0.687011C12.3305 0.687011 12.0768 0.797476 11.89 0.99404L6.99997 6.11669L2.10997 0.983543C1.92314 0.786979 1.66949 0.676514 1.40497 0.676514C1.14045 0.676514 0.886802 0.786979 0.699971 0.983543C0.309971 1.39293 0.309971 2.05426 0.699971 2.46365L5.58997 7.5968L0.699971 12.73C0.309971 13.1393 0.309971 13.8007 0.699971 14.2101C1.08997 14.6195 1.71997 14.6195 2.10997 14.2101L6.99997 9.07691L11.89 14.2101C12.28 14.6195 12.91 14.6195 13.3 14.2101C13.69 13.8007 13.69 13.1393 13.3 12.73L8.40997 7.5968L13.3 2.46365C13.68 2.06476 13.68 1.39294 13.3 0.99404Z" fill="black" fill-opacity="0.6" />
                                        </svg>
                                    </span>
                                </template>
                            </gofix-button>
                            <gofix-button class="icon-svg icon-svg-left mb-2" label="Add file" outline @click="modals.attachment.open = true">
                                <template slot="gofix:button:beforeLabel">
                                    <span class="icon">
                                        <svg width="23" height="19" viewBox="0 0 23 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M11.6537 8.20604C11.6355 8.1827 11.6121 8.16382 11.5855 8.15083C11.5588 8.13785 11.5296 8.1311 11.4999 8.1311C11.4703 8.1311 11.441 8.13785 11.4144 8.15083C11.3877 8.16382 11.3644 8.1827 11.3461 8.20604L8.61175 11.6655C8.58921 11.6943 8.57522 11.7288 8.57139 11.7652C8.56755 11.8016 8.57403 11.8383 8.59007 11.8711C8.60612 11.904 8.63108 11.9317 8.66212 11.951C8.69315 11.9703 8.72899 11.9805 8.76556 11.9805H10.5698V17.8984C10.5698 18.0058 10.6576 18.0937 10.7651 18.0937H12.2299C12.3373 18.0937 12.4252 18.0058 12.4252 17.8984V11.9829H14.2343C14.3979 11.9829 14.4882 11.7949 14.3881 11.668L11.6537 8.20604Z" fill="#F05600" />
                                            <path d="M18.8096 5.95264C17.6914 3.00342 14.8423 0.90625 11.5049 0.90625C8.16748 0.90625 5.31836 3.00098 4.2002 5.9502C2.10791 6.49951 0.5625 8.40625 0.5625 10.6719C0.5625 13.3696 2.74756 15.5547 5.44287 15.5547H6.42188C6.5293 15.5547 6.61719 15.4668 6.61719 15.3594V13.8945C6.61719 13.7871 6.5293 13.6992 6.42188 13.6992H5.44287C4.62012 13.6992 3.84619 13.3721 3.27002 12.7788C2.69629 12.188 2.39111 11.3921 2.41797 10.5669C2.43994 9.92236 2.65967 9.31689 3.05762 8.80664C3.46533 8.28662 4.03662 7.9082 4.67139 7.73975L5.59668 7.49805L5.93604 6.60449C6.146 6.04785 6.43896 5.52783 6.80762 5.05664C7.17156 4.58962 7.60267 4.17908 8.08691 3.83838C9.09033 3.13281 10.272 2.75928 11.5049 2.75928C12.7378 2.75928 13.9194 3.13281 14.9229 3.83838C15.4087 4.18018 15.8384 4.59033 16.2021 5.05664C16.5708 5.52783 16.8638 6.05029 17.0737 6.60449L17.4106 7.49561L18.3335 7.73975C19.6567 8.09619 20.582 9.2998 20.582 10.6719C20.582 11.48 20.2671 12.2417 19.6958 12.813C19.4156 13.0948 19.0823 13.3182 18.7152 13.4703C18.3481 13.6225 17.9545 13.7003 17.5571 13.6992H16.5781C16.4707 13.6992 16.3828 13.7871 16.3828 13.8945V15.3594C16.3828 15.4668 16.4707 15.5547 16.5781 15.5547H17.5571C20.2524 15.5547 22.4375 13.3696 22.4375 10.6719C22.4375 8.40869 20.897 6.5044 18.8096 5.95264Z" fill="#F05600" />
                                        </svg>
                                    </span>
                                </template>
                            </gofix-button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="text-center mt-1">
                <gofix-button class="mw-250 mr-md-3 mb-sm-20" label="Back" large @click="prevStepOne" outline></gofix-button>
                <gofix-button class="mw-250" label="Next" large :disabled="!feedback.location || !nature_feedback_model || !feedback.feedback_detail" @click="step = 3"></gofix-button>
            </div>
        </div>

    </transition>
    <transition name="fade" mode="out-in" v-if="step === 3">
        <div class="tenantCard tenantForm tenantReview">
            <div class="header text-center">
                <h3>Review </h3>
            </div>
            <div class="main">
                <div class="fields">
                    <div class="field span-12">
                        <gofix-text-field class="mb-3" label="Site /Property" oneline>{{site_name || feedback.location.name}}</gofix-text-field>
                    </div>
                    <div class="field span-12">
                        <gofix-text-field class="mb-3" label="Location" oneline>{{feedback.location.root_path}}</gofix-text-field>
                    </div>
                    <div class="field span-12">
                        <gofix-text-field class="mb-3" label="Nature of Feedback" oneline>{{nature_feedback_model ? nature_feedback_model.name : ''}}</gofix-text-field>
                    </div>
                    <div class="field span-12">
                        <gofix-text-field class="mb-3" label="Type of Service" oneline>{{feedback.service_category ? feedback.service_category.name : ''}}</gofix-text-field>
                    </div>
                    <div class="field span-12">
                        <gofix-text-field class="mb-3" label="Feedback Detail" oneline>{{feedback.feedback_detail}}</gofix-text-field>
                    </div>
                    <div class="field span-12">
                        <gofix-text-field class="mb-3" label="Attachments" oneline>
                            <gofix-button class="icon-svg mr-2 mb-2" v-for="(attachment,index) in feedback.attachments" :label="attachment.name" outline dark :key="index">
                            </gofix-button>
                        </gofix-text-field>
                    </div>
                </div>
                <hr />
                <div class="fields">
                    <div class="field span-12">
                        <gofix-text-field class="mb-3" label="Salutation" oneline>{{requestor.salutation}}.</gofix-text-field>
                    </div>
                    <div class="field span-6">
                        <gofix-text-field class="mb-3" label="First Name" oneline>{{requestor.first_name}}</gofix-text-field>
                    </div>
                    <div class="field span-6">
                        <gofix-text-field class="mb-3" label="Last Name" oneline>{{requestor.last_name}}</gofix-text-field>
                    </div>
                    <div class="field span-6">
                        <gofix-text-field class="mb-3" label="Company" oneline>{{requestor.company}}</gofix-text-field>
                    </div>
                    <div class="field span-6">
                        <gofix-text-field class="mb-3" label="Email" oneline>{{requestor.email}}</gofix-text-field>
                    </div>
                    <div class="field span-6">
                        <gofix-text-field class="mb-3" label="Office Phone Number" oneline>{{requestor.primary_phone}}</gofix-text-field>
                    </div>
                    <!-- <div class="field span-6">
                        <gofix-text-field class="mb-3" label="Mobile Number" oneline>{{requestor.secondary_phone}}</gofix-text-field>
                    </div> -->
                    <div class="field span-12">
                        <gofix-text-field class="mb-3" label="Preferred Mode of Contact" oneline>{{requestor.preferred_contact_mode}}</gofix-text-field>
                    </div>

                    <div class="field span-12 text-center">
                        <gofix-button class="mr-md-3 mb-sm-20" label="Back" large outline @click="step = 2"></gofix-button>
                        <gofix-button label="Submit" large @click="raiseCase"></gofix-button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
    <!--Modals-->
    <b-modal :no-close-on-backdrop="true" title="import file" ref="modal-Import-attachments" id="modal-Contract-Attachments" modal-class="gofixUploadFileModal" hide-footer v-model="modals.attachment.open">
        <b-form class="formV2">
            <b-form-group :label="modals.attachment.filename" >
                <b-form-file ref="file-input" v-model="modals.attachment.fileAttachment" ></b-form-file>
            </b-form-group>
            <!-- <b-form-group>
                <b-form-file ref="file-input" v-model="modals.attachment.fileAttachment">
                    <template slot="file-name" slot-scope="{ names }">
                        <span class="import-input-text-ellipsis" variant="dark">{{ names[0] }}</span>
                    </template>
                </b-form-file>
            </b-form-group> -->
            <b-button-group class="text-right d-block">
                <gofix-button label="SUBMIT" @click="addAttachment" noBorder :loading="modals.attachment.loading"></gofix-button>
            </b-button-group>
        </b-form>
    </b-modal>
</div>
</template>

<script>
import moment from 'moment';
const simulateAsyncOperation = fn => {
    setTimeout(fn, 500);
};
export default {
    name: 'tenant-form',
    props: {
        propertyId: {
            type: [Number, String],
            default: () => null
        },
        siteId: {
            type: [Number, String],
            default: () => null
        },
        userLogged: {
            type: Object,
            default: () => null
        }
    },
    data() {
        return {
            loadings: {
                login: false,
                property: false,
                site: false,
                raiseCase: false,
            },
            properties: {
                root: this.propertyId,
                tree: []
            },
            tenantForm: "guest",
            step: 1,
            user: {
                email: null,
                password: null
            },
            user_info: null,
            passwordType: "password",
            requestor: {
                salutation: null,
                first_name: null,
                last_name: null,
                company: null,
                email: null,
                primary_phone: null,
                secondary_phone: null,
                preferred_contact_mode: null,
                user_id: null,
                contact_id: null,
                company_id: null,
            },
            site_name: '',
            feedback: {
                attachments: [],
                location: null,
                service_category: null,
                nature_feedback_id: null,
                feedback_detail: null,
                reported_date: new Date(),
                reported_time: moment(new Date()).format("HH:mm"),
            },
            treeNatureFeedBack:[],
            treeServiceCategory: [],
            nature_feedback_model:null,
            site_model:null,
            normalizerNatureFeedBack(node) {
                if (node.data.isBatch)
                    return {
                        id: node.data.id,
                        label: node.text,
                        children: node.children
                    };
                return {
                    id: node.data.id,
                    label: node.name,
                    children: undefined
                };
            },
            normalizerServiceCategory(node) {
                if (node.data.isBatch)
                    return {
                        id: node.data.id,
                        label: node.text,
                        children: node.children
                    };
                return {
                    id: node.data.id,
                    label: node.name,
                    children: undefined
                };
            },
            loading:{
                nature_feedback:false
            },
            modals: {
                attachment: {
                    open: false,
                    loading: false,
                    filename: "Click Browse to upload file",
                    fileAttachment: null,
                    edit: 0
                }
            },
            sites: [],
            salutationOptions:[],
            preferred_mode:[],
            // natureOfFeedbackOptions:[],
            is_show_icon_pwd:false,
            client_contract_id: null,
            isSign: false
        }
    },
    watch: {
        "modals.attachment.fileAttachment": function (val, old) {
            this.modals.attachment.filename = 'Click Browse to upload file';
            if (val) {
                let extensionAccept = ['jpeg', 'jpg', 'png', 'gif'];
                let extensionArray = val.name.split('.');
                let extension = extensionArray[extensionArray.length - 1].toLowerCase();
                if(!extensionAccept.includes(extension)) {
                    this.$refs['file-input'].reset()
                    return this.$bvToast.toast('File format is incorrect. Please select a .jpeg, .jpg, .png, .gif file!', {
                        title: `Notification`,
                        autoHideDelay: 3000,
                        variant: 'warning',
                        solid: true
                    })
                }
                this.modals.attachment.filename = val.name
            }
        },
        "modals.attachment.open": function (val) {
            if(val) {
                this.modals.attachment.fileAttachment = null;
                this.modals.attachment.filename = 'Click Browse to upload file';
            }
        },
        "site_model": function (val, old) {
            this.properties.root = val.property_id;
            this.getProperties();
            if(this.properties.root && this.propertyId) {
                this.getPropertyValue();
            }
            if(val.client_contract_id){
                this.loadRootNatureFeedBack(val.client_contract_id);
                this.loadRootServiceCategory(val.client_contract_id);
            }
        },
        "feedback.location": function (val) {
            let root_path = val.root_path;
            let index = root_path.lastIndexOf(">> " + val.name)
            if (index !== -1) {
                let subStr = root_path.substring(index);
                this.site_name = root_path.replace(subStr, "");
            } else {
                this.site_name = val.name;
            }
        },
        "user.password":function(val){
            if(val){
                this.is_show_icon_pwd = true;
            }else{
                this.is_show_icon_pwd = false;
            }
        },
        propertyId: function (val) {
            if(val) {
                this.getPropertyValue();
            }
        },
        step: function (val) {
            if(val && val == 2 && this.propertyId && this.tenantForm == "guest") {
                this.properties.root = this.propertyId;
            }
        }
    },
    created() {
        if(this.userLogged) {
            this.user_info = this.userLogged;
            this.requestor.user_id = this.userLogged.user_detail.id;
            if (this.userLogged.user_detail.contact_address) {
                this.requestor.contact_id = this.userLogged.user_detail.contact_address.id;
                this.requestor.primary_phone = this.userLogged.user_detail.contact_address.primary_phone;
                this.requestor.secondary_phone = this.userLogged.user_detail.contact_address.secondary_phone;
                this.requestor.first_name = this.userLogged.user_detail.contact_address.first_name;
                this.requestor.last_name = this.userLogged.user_detail.contact_address.last_name;
                this.requestor.email = this.userLogged.user_detail.contact_address.email;
                this.requestor.salutation = this.userLogged.user_detail.contact_address.salutation;
            }
            if (!this.requestor.email) {
                this.requestor.email = this.userLogged.user_detail.email;
            }
            this.requestor.preferred_contact_mode = this.userLogged.user_detail.preferred_contact_mode || "Email";
            this.properties.root = this.userLogged.tenant.property_id;
            this.step = 2;
        }
        
        if (this.properties.root) {
            this.getProperties();
        }
        if (!this.propertyId) {
            this.getTenantSite();
        } else {
            this.getPropertyValue();
        }

        this.getSalutations();
        this.getPreferredMode();
        // this.getNatureOfFeedbackOptions();
    },
    methods: {
        prevStepOne() {
            this.$emit("prev-step", 1);
            this.step = 1;
        },
        showGuest() {
            this.tenantForm = 'guest';
            this.requestor = {
                salutation: null,
                first_name: null,
                last_name: null,
                company: null,
                email: null,
                primary_phone: null,
                secondary_phone: null,
                preferred_contact_mode: null,
                user_id: null,
                contact_id: null,
                company_id: null,
            }
            this.isSign = false
        },
        changePasswordType() {
            if (this.passwordType === 'text') {
                this.passwordType = 'password';
            } else {
                this.passwordType = 'text';
            }
        },
        checkUser() {
            if (this.loadings.login) return;
            this.loadings.login = true;
            //Check required field
            if (!this.user.email) {
                return this.$bvToast.toast('The email is required field!', {
                    title: `Notification`,
                    autoHideDelay: 3000,
                    variant: 'danger',
                    solid: true
                })
            }
            if (!this.user.password) {
                return this.$bvToast.toast('The email is required field!', {
                    title: `Notification`,
                    autoHideDelay: 3000,
                    variant: 'danger',
                    solid: true
                })
            }
            //Check user
            this.$store.dispatch('AuthController/loginTenant', {
                    email: this.user.email.trim(),
                    password: this.user.password.trim(),
                    tenant: true
                })
                .then(response => {
                    //Set data user
                    let user = response.data.data;
                    this.user_info = user;
                    this.requestor.user_id = user.user_detail.id;
                    if (user.user_detail.contact_address) {
                        this.requestor.contact_id = user.user_detail.contact_address.id;
                        this.requestor.primary_phone = user.user_detail.contact_address.primary_phone;
                        this.requestor.secondary_phone = user.user_detail.contact_address.secondary_phone;
                        this.requestor.first_name = user.user_detail.contact_address.first_name;
                        this.requestor.last_name = user.user_detail.contact_address.last_name;
                        this.requestor.email = user.user_detail.contact_address.email;
                        this.requestor.salutation = user.user_detail.contact_address.salutation;
                    }
                    if (!this.requestor.email) {
                        this.requestor.email = user.user_detail.email;
                    }
                    this.requestor.preferred_contact_mode = user.user_detail.preferred_contact_mode || "Email";
                    this.properties.root = user.tenant.property_id;
                    this.step = 2;
                    this.loadings.login = false;
                })
                .catch(err => {
                    this.loadings.login = false;
                    if (err.response.data.message || err.response.data.error.message.error) {
                        let mess = err.response.data.message || err.response.data.error.message.error;
                        this.$bvToast.toast(mess, {
                            title: `Notification`,
                            autoHideDelay: 3000,
                            variant: 'danger',
                            solid: true
                        })
                    }
                })
        },
        getProperties() {
            if (this.loadings.property) return;
            this.loadings.property = true;
            //TenantsController
            this.$store.dispatch('TenantsController/getProperties', {
                    property_id: this.properties.root
                })
                .then(response => {
                    this.properties.tree = response;
                    this.loadings.property = false;
                })
                .catch(err => {
                    this.properties.tree = null;
                    this.loadings.property = false;
                })
        },
        getTenantSite() {
            this.$store.dispatch("TenantSiteController/getItems", {
                    page: 1,
                    limit: -1,
                    sortColumn: "site_name",
                    sortDirection: "asc",
                    filter: null
                })
                .then(response => {
                    this.sites = response.items;
                })
                .catch(err => {
                    this.sites = [];
                })
        },
        normalizerProperties(node) {
            return {
                label: node.name,
                children: (node.children && node.children.length) ? node.children : undefined
            }
        },
        addAttachment() {
            if(!this.modals.attachment.fileAttachment) {
                return this.$bvToast.toast('Please select the file.', {
                    title: `Notification`,
                    autoHideDelay: 3000,
                    variant: 'danger',
                    solid: true
                })
            }
            this.feedback.attachments.push(this.modals.attachment.fileAttachment);
            this.modals.attachment.fileAttachment = null;
            this.modals.attachment.open = false;
        },
        removeImage(index) {
            this.feedback.attachments.splice(index, 1);
        },
        raiseCase() {
            if (this.loadings.raiseCase) return;
            this.loadings.raiseCase = true;
            //Required
            if (!this.feedback.location) {
                return this.$bvToast.toast('Please select a location', {
                    title: `Notification`,
                    autoHideDelay: 3000,
                    variant: 'danger',
                    solid: true
                })
            }
            //raiseCase
            let data = {
                property_id: this.properties.root,
                location_id: this.feedback.location ? this.feedback.location.id : 0,
                //nature_of_feedback: this.feedback.nature_of_feedback,
                nature_feedback_id: this.nature_feedback_model && this.nature_feedback_model.id,
                feedback_detail: this.feedback.feedback_detail,
                requestor: this.requestor,
                attachments: this.feedback.attachments,
                service_category_id: this.feedback.service_category ? this.feedback.service_category.id : 0,
            };
            this.$store.dispatch('TenantsController/raiseCase', data)
                .then(response => {
                    this.$emit("next-step", this.user_info);
                    this.loadings.raiseCase = false;
                })
                .catch(err => {
                    this.loadings.raiseCase = false;
                    return this.$bvToast.toast("Can't create case!", {
                        title: `Notification`,
                        autoHideDelay: 3000,
                        variant: 'danger',
                        solid: true
                    })
                })
        },
        getSalutations(){
            let filter = {reference_type: "Salutation"};
            let params = {
                filter: filter,
                limit: -1,
                sortColumn: "id",
                sortDirection: "asc",
            };
            this.$store.dispatch(`ReferenceController/getItems`, params)
                .then(response => {
                    this.salutationOptions = response.items;
                })
        },
        getPreferredMode(){
            let filter = {reference_type: "Preferred Mode of Contact"};
            let params = {
                filter: filter,
                limit: -1,
                sortColumn: "id",
                sortDirection: "asc",
            };
            this.$store.dispatch(`ReferenceController/getItems`, params)
                .then(response => {
                    this.preferred_mode = response.items;
                })
        },
        // getNatureOfFeedbackOptions(){
        //     let filter = {reference_type: "Nature Of Feedback Options"};
        //     let params = {
        //         filter: filter,
        //         limit: -1,
        //         sortColumn: "id",
        //         sortDirection: "asc",
        //     };
        //     this.$store.dispatch(`ReferenceController/getItems`, params)
        //         .then(response => {
        //             this.natureOfFeedbackOptions = response.items;
        //         })
        // },
        async getPropertyValue() {
            this.$store.dispatch("TenantsController/getProperty", {
                property_id: this.propertyId,
                parent_id: this.properties.root,
                is_load_contract: true
            })
            .then(result => {
                this.feedback.location = result;
                if(this.feedback.location && this.feedback.location.client_contract_id) {
                    this.client_contract_id = this.feedback.location.client_contract_id;
                    this.loadRootNatureFeedBack(this.client_contract_id)
                    this.loadRootServiceCategory(this.client_contract_id)
                }
            }).catch(error => {
                console.log(error)
            });
        },
        loadRootNatureFeedBack(contract_id) {  
            this.loading.nature_feedback = true;
            global.axios(`api/tenants/${contract_id}/tree-nature-feedback/0`, {
                    method: "GET",
                    headers: {
                        Accept: "application/json",
                    },
                    params: {
                        isBrowser: true
                    }
                })
                .then(response => {
                    this.treeNatureFeedBack = response.data.data;
                    this.loading.nature_feedback = false;

                }).catch(error => {});
        },
        loadOptionNatureFeedBack({
            action,
            parentNode,
            callback
        }) {
            simulateAsyncOperation(async () => {
                if(this.client_contract_id) parentNode.children = await this.getNatureFeedBack(parentNode.data.id, this.client_contract_id)
                else parentNode.children = null
                callback()
            })
        },
        getNatureFeedBack(nature_feedback_root_id, contract_id) {
            return new Promise((resolve, reject) => {
                global.axios(`api/tenants/${contract_id}/tree-nature-feedback/${nature_feedback_root_id}`, {
                        method: "GET",
                        headers: {
                            Accept: "application/json",
                        },
                        params: {
                            isBrowser: true
                        }
                    })
                    .then(response => {
                        resolve(response.data.data)
                    }).catch(error => {});
            });
        },
        loadRootServiceCategory(contract_id) {
            this.loading.service_category = true;
            global.axios(`api/tenants/${contract_id}/tree-service-categories/0`, {
                    method: "GET",
                    headers: {
                        Accept: "application/json",
                    },
                    params: {
                        isBrowser: true
                    }
                })
                .then(response => {
                    this.treeServiceCategory = response.data.data;
                    this.loading.service_category = false;

                }).catch(error => {});
        },
        loadOptionServiceCategory({
            action,
            parentNode,
            callback
        }) {
            simulateAsyncOperation(async () => {
                parentNode.children = await this.getServiceCategory(parentNode.data.id, this.client_contract_id)
                callback()
            })
        },
        getServiceCategory(service_category_root_id, contract_id) {
            return new Promise((resolve, reject) => {
                global.axios(`api/tenants/${contract_id}/tree-service-categories/${service_category_root_id}`, {
                        method: "GET",
                        headers: {
                            Accept: "application/json",
                        },
                        params: {
                            isBrowser: true
                        }
                    })
                    .then(response => {
                        resolve(response.data.data)
                    }).catch(error => {});
            });
        },
    }
}
</script>
